import React, { FC } from 'react';
import { Text, View } from 'react-native';
import { font as initialFont } from '@styles/fonts';
import i18n from 'i18n-js';
import { scale as initialScale } from '@components/frame';
import moment from 'moment';
import { connect } from 'react-redux';
import TimeDisplayInStaticFormat from '@components/common/TimeDisplayInStaticFormat';
import { HomePageCentralPartProps } from '@components/operatorPanel/components/HomePage/HomePageCentralPart';

interface MachineRunningNoNCFileCentralPartProps extends Pick<HomePageCentralPartProps, 'CC' | 'scale' | 'font'> {
  executionMode: string;
  offset: number;
  lastUpdatedOn: string;
}

const MachineRunningNoNCFileCentralPart: FC<MachineRunningNoNCFileCentralPartProps> = ({ CC, executionMode, offset, lastUpdatedOn, scale = initialScale, font = initialFont }) => {
  const time = moment.utc().add(offset, 'milliseconds');

  const runningTime = time.diff(lastUpdatedOn ? moment.utc(lastUpdatedOn) : moment.utc(), 's');

  return (
    <View style={{ alignItems: 'center' }}>
      <Text style={[font['Large Title'], { color: CC('Label/Dark/Primary'), textAlign: 'center', marginBottom: scale(3) }]}>{i18n.t('Active')}</Text>
      <TimeDisplayInStaticFormat
        {...{ timeValue: runningTime, C: CC, shouldRunTime: true, color: CC('Label/Light/Always Light Tertiary'), colorAlreadyParsed: true, fontForDigit: 'Body Extra Large', fontForSecondDigit: 'Time 2' }} 
      />
      <Text style={[font['Body Extra Large'], { color: CC('Label/Light/Always Light Tertiary'), textAlign: 'center', marginTop: scale(44) }]}>
        {i18n.t('Execution Mode')}: {i18n.t(executionMode)}
      </Text>
    </View>
  );
};

export default connect(
  ({
    time: {
      server: { offset },
    },
  }) => ({ offset })
)(MachineRunningNoNCFileCentralPart);
